import React, { FC, ReactElement } from "react";
import { Badge, Tooltip } from "@mui/material";
import MaterialAvatar from "../general/MaterialAvatar";
import { useTheme } from '@mui/material/styles';

interface IUser {
    name: string;
    photoURL: string;
}

interface ITypedAvatarProps {
    typeIcon: ReactElement;
    user: IUser;
    tooltipTitle?: string | ReactElement;
}

const TypedAvatar: FC<ITypedAvatarProps> = (props) => {
    const {typeIcon, user, tooltipTitle} = props;
    const theme = useTheme();
    return (
        <Tooltip title={tooltipTitle}>
            <Badge
                badgeContent={typeIcon}
                color="primary"
                sx={{
                    ".MuiBadge-badge": {
                        height: "24px",
                        width: "24px",
                        borderRadius: "50%",
                        backgroundColor: "#e7f1fa",
                        border: `2px solid ${theme?.custom?.white}`,
                        right: "10%",
                        bottom: "10%",
                        ".MuiSvgIcon-root": {
                            fontSize: "14px",
                            color: theme?.custom?.mainButtonHighlight,
                        },
                    },
                }}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                overlap="circular"
            >
                <MaterialAvatar user={user} />
            </Badge>
        </Tooltip>
    );
};

TypedAvatar.defaultProps = {
    tooltipTitle: null,
}

export default TypedAvatar;
